<template lang="pug">
	main
		google-map
		.separator
		section.contacto
			.container-padded
				.container-form.center
					h1.title.center.blue Siempre en Contacto
					h3.subtitle.black.center Dudas, sugerencias y cotizaciones
					.separator-half
					form
						.row-form
							label Nombre
							input(type="text" name="nombre")
						.row-form
							label Email
							input(type="text" name="nombre")
						.row-form
							label Mensaje
							textarea
						input(type="submit" value="Enviar" class="button filled")
				.separator
				//https://www.google.com.mx/maps/place/Benjam%C3%ADn+Eguiluz+125,+Tetl%C3%A1n,+44820+Guadalajara,+Jal./@20.6618895,-103.2784907,17z/data=!3m1!4b1!4m5!3m4!1s0x8428b3fae7b13f5f:0xb55b43de16811945!8m2!3d20.6618845!4d-103.2762966
</template>
<style lang="scss" scoped>
	#nav {
		background: #fff;
    	position: initial;
	}
  @import "../styles/global.scss";
</style>
<script>
	import GoogleMap from "./../components/GoogleMap";
	export default {
		components : {
			GoogleMap
		}
	}
</script>